import { jsx, jsxs } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import React from "react";
import { StyledChip, StyledTypography } from "./styled";
import { Icon } from "../Icon";
const Chip = React.forwardRef((props, ref) => {
  const {
    size = "xxs",
    variant = "primary",
    color = "contrast",
    children,
    endIcon,
    startIcon,
    ...rest
  } = props;
  const theme = useTheme();
  const variantTypography = theme.chip.typography[size];
  const iconSize = theme.chip.icon[size];
  return /* @__PURE__ */ jsxs(
    StyledChip,
    {
      ...rest,
      ref,
      size,
      variant,
      color,
      isOnlyIcon: !children,
      children: [
        startIcon && /* @__PURE__ */ jsx(Icon, { icon: startIcon, size: iconSize }),
        children && /* @__PURE__ */ jsx(StyledTypography, { variant: variantTypography, children }),
        endIcon && /* @__PURE__ */ jsx(Icon, { icon: endIcon, size: iconSize })
      ]
    }
  );
});
var Chip_default = Chip;
export {
  Chip_default as default
};
